import Utils from '../common/Utils';
import Swiper from 'swiper';
import {API_DOMAIN, GLOBAL_PATH, STORE} from '../common/Model';

export default class Movie {
	constructor(_config) {
``
		this.config = _config;
		this.serviceEnv = _config.serviceEnv.toUpperCase() || 'LIVE';
		let _option = {
			type: 'api',
			service : this.config.service,
			country : this.config.country,
			menu : 'movie'
		};
		let _communityApi;
		if (this.config.service==='lineage2mru' || this.config.service==='lineage2mnaeu') {
			_communityApi = API_DOMAIN.GLOBAL_COMMUNITY[this.serviceEnv];
		} else if (this.config.service ==='lineage2mnct') {
			_communityApi = API_DOMAIN.NCT_COMMUNITY[this.serviceEnv];
		} else if (this.config.service ==='lineage2mncj') {
			_communityApi = API_DOMAIN.NCJ_COMMUNITY[this.serviceEnv];
		} else {
			_communityApi = API_DOMAIN.COMMUNITY[this.serviceEnv];
		}

		this.movieApiUrl =  _communityApi + GLOBAL_PATH(_option);
		this.TITLE = _config.tabConfig.tabCmpick.cmpickMovie.title || STORE.title.movie;

		let _optionUrl = {
			type: 'url',
			service : this.config.service,
			menu : 'movie',
			locale : this.config.locale,
			country : this.config.country
		};
		this.moviePathUrl = GLOBAL_PATH(_optionUrl);
		// console.log( '=> movie.js this.movieApiUrl : ', this.movieApiUrl);
	}
	init() {
		if( Utils.isEmptyObject(STORE.data.movie) ) {
			this.get();
		} else {
			this.render(STORE.data.movie);
		}
	}
	get() {
		const _this =  this;
		fetch(this.movieApiUrl, {
			dataType: "json",
			type: "GET"/*,
			headers: {
				'Content-Type': 'application/json', 'Accept': 'application/json'
			}*/
		}).then(function (response) { // The API call was successful!
			if (response.ok) {
				return response.json();
			} else {
				return Promise.reject(response);
			}
		}).then(function (data) { // This is the JSON from our response
			let _resData = (data.articleList) ? data.articleList : data.contentList;
			if(! _resData || _resData.length <= 0 ) return;
			STORE.data.movie = _resData;
			_this.render(_resData);
		}).catch(function (err) { // There was an error
			// console.warn('Something went wrong.', err);
			console.log('오류가 발생했습니다.', err);
		});
		/*$.ajax({
			dataType: "json",
			type: "GET",
			//headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
			data: {
				summary: false,
				moreSize: 3,
				previousArticleId: 0,
				categoryId: 0,
			},
			url: `${this.movieApiUrl}`
		})
		.fail( xhr => console.log('오류가 발생했습니다.') )
		.done(( data ) => {
			// console.log('=> movie data : ' , data);
			let _resData = (data.articleList) ? data.articleList : data.contentList;
			if(! _resData || _resData.length <= 0 ) return;
			STORE.data.movie = _resData;
			this.render(_resData);
		});*/
	}

	render(data) {
		const wrapper = document.querySelector('.movie-wrapper');
		let tmpl = this.templ(data);
		wrapper.innerHTML = tmpl;
		this.addEvent();
	}

	templ(_d){
		let _title = `<a href="${this.moviePathUrl}list"><h3>${this.TITLE}</h3><i class="icon-more"></i></a>`;
		return `
			<header class="movie-header">
			${_title}
			</header>
			<article class="movie-list swiper" ${this.config.isRtl ? 'dir="rtl"' : '' }>
				<div class="swiper-wrapper">
					${_d.map( (item, index) => {
						if(index<3) return this.listTempl(item);
					}).join('')}
				</div>
			</article>`;
	}

	listTempl(_a) {
		// console.log('# movie.js  : ', _a.ul, _a.thumbnailUrl, _a.title);
		let _url = _a.url ? _a.url : `${this.moviePathUrl}view?articleId=${_a.id}`;
		return `
		<div class="movie-item swiper-slide">
			<a class="movie-link" href="${_url}">
				<div class="movie-thumb">
					${_a.thumbnailUrl ? `<img alt="" src="${_a.thumbnailUrl}">` : ``}
					<div class="movie-info">
						<i class="icon-play"></i>
					</div>
				</div>
				<div class="movie-text">
					<div class="movie-title">${_a.title}</div>
				</div>
			</a>
		</div>`;
	}

	addEvent() {
		let movieSwiper;
		function setMovieSwiper() {
			// console.log('# setMovieSwiper()');
			movieSwiper = new Swiper('.movie-list', {
				slidesPerView: 'auto',
				slidesPerGroup: 3,
				spaceBetween: 0,
				breakpoints: {
					639: {
						spaceBetween: 0
					},
				}
			});
		}
		function resetMovieSwiper() {
			let width = window.innerWidth;
			if (width > 640) {
				if (movieSwiper) {
					movieSwiper.destroy(true, true);
					movieSwiper = undefined;
				}
			}
			if (width <= 639) {
				if (!movieSwiper) {
					setMovieSwiper();
				}
			}
		}
		setMovieSwiper();

		/*$(window).on('resize', this.onWindowResize);
		function onWindowResize () {
			resetMovieSwiper();
		}*/
		window.addEventListener('resize', (evt) => {
			resetMovieSwiper();
		});
	}

}